'use client';

import { useEffect, useState, ReactNode, useRef } from 'react';

interface AnimationPresenceProps {
  visible: boolean;
  children: ReactNode;
  className?: string;
  enterClass?: string;
  exitClass?: string;
}

export function AnimationPresence({
  visible,
  children,
  className = '',
  enterClass = '',
  exitClass = '',
}: AnimationPresenceProps) {
  const [shouldRender, setShouldRender] = useState(visible);
  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    if (visible) {
      setShouldRender(true);

      setAnimationClass(enterClass);
    } else {
      setAnimationClass(exitClass);
    }
  }, [visible, enterClass, exitClass]);

  const handleAnimationEnd = () => {
    if (!visible) {
      setShouldRender(false);
    }
  };

  return shouldRender ? (
    <div className={`${className} ${animationClass}`} onAnimationEnd={handleAnimationEnd}>
      {children}
    </div>
  ) : null;
}
